import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const headerRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  // Scroll detection for style changes
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Hardcoded navigation items
  const navItems = [
    { label: "Home", path: "/" },
    { label: "About", path: "/aboutus" },
    { label: "Pillars", path: "/pillars" },
    { label: "Products", path: "/products" },
    { label: "Solutions", path: "/solutions" },
    { label: "Research", path: "/research" },
    { label: "Partners", path: "/partners" }
     // example page
  ];

  const ctaItem = { label: "Contact", path: "/contact" };

  const handleNavClick = (path) => {
    if (location.pathname === path) {
      try { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); } catch {}
    } else {
      navigate(path);
    }
    setMobileOpen(false);
  };

  return (
    <header
      ref={headerRef}
      className={`header${scrolled ? " header-scrolled" : ""}`}
      role="navigation"
    >
      <div className="header-inner">
        {/* Logo */}
        <div className="header-logo">
          <span className="logo-text glow" onClick={() => navigate("/")}>
            IQ Leap
          </span>
        </div>

        {/* Navigation */}
        <nav className={`header-nav${mobileOpen ? " nav-open" : ""}`}>
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`nav-link${location.pathname === item.path ? " nav-active" : ""}`}
              onClick={() => handleNavClick(item.path)}
              tabIndex={0}
              aria-current={location.pathname === item.path ? "page" : undefined}
            >
              {item.label}
              <span className="nav-underline" />
            </button>
          ))}

          {/* CTA Button */}
          <button
            className="nav-cta"
            onClick={() => handleNavClick(ctaItem.path)}
            tabIndex={0}
          >
            {ctaItem.label}
          </button>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className={`header-hamburger${mobileOpen ? " open" : ""}`}
          aria-label="Open menu"
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile backdrop */}
      {mobileOpen && <div className="header-backdrop" onClick={() => setMobileOpen(false)} />}
    </header>
  );
};

export default Header;
